import { LinkItem } from '@occc-app/design-system';
import { routeCreator as programManagementRouteCreator } from '@occc-app/routes/ProgramManagement/utils';

import { routeCreator } from '../utils';

export const breadcrumbLinks: LinkItem[] = [
  { to: programManagementRouteCreator.base(), label: 'Program Management' },
  { key: routeCreator.create(), label: 'Create Product Group' },
];
